import { IconUpload } from '@tabler/icons-react';

export default function PdfDropZone({
    title,
    hint,
    isDragging,
    onClick,
    onDragOver,
    onDragLeave,
    onDrop,
    onKeyDown,
    className = '',
}) {
    return (
        <div
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={onKeyDown}
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
            className={`flex w-full cursor-pointer flex-col items-center gap-2 rounded-[14px] border-[1.5px] border-dashed border-pdf-cat-solid bg-pdf-cat-tint px-4 py-6 transition-colors dark:border-orange-700 dark:bg-orange-950/20 ${
                isDragging ? 'border-primary bg-primary/5' : 'hover:border-[#c93d22]'
            } ${className}`}
        >
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-white text-pdf-cat-solid shadow-[0_1px_2px_rgba(28,24,21,0.04)] dark:bg-zinc-900 dark:text-orange-400">
                <IconUpload size={21} stroke={1.8} />
            </div>
            <div className="text-sm font-semibold text-[#1C1815] dark:text-zinc-100">{title}</div>
            {hint ? (
                <div className="text-xs text-[#A8A099] dark:text-zinc-500">{hint}</div>
            ) : null}
        </div>
    );
}
